import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { CURRENCY, ITEMSTATUS, TYPESOFORDERS } from "../../../contants";

import ItemQuantitySelector from "./ItemQuantitySelector";
import { Button, Collapse } from "react-bootstrap";
import ListItemSelector from "./ListItemSelector";
import price from "../../../helpers/calculatePrice";
import CommonImportModal from "../../../components/common/Modals/CommonImportModal";
import OrderConfirmation from "./OrderConfirmation";

const getColor = (type) => {
  if (type === 1) {
    return { backgroundColor: "#ffeaad" };
  }
  if (type === 2) {
    return { backgroundColor: "#c6ffba" };
  }
  if (type === 0) {
    return { backgroundColor: "#e3c8fa" };
  }
};

const boxStyle = {
  cursor: "pointer",
  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap",
  display: "inline-block",
  padding: "0.25em 0.4em",
  verticalAlign: "baseline",
  borderRadius: "0.25rem",
  backgroundColor: "rgba(31, 140, 45, 0.15)",
  color: "#1f8c2d",
  boxShadow: "0px 0px 13px 0px rgb(31 140 45 / 5%)",
};

export const getBgColor = (type, kotQuantity, quantity) => {
  const percentage = (kotQuantity / quantity) * 100;
  if (type === 1) {
    return `linear-gradient(90deg,#ffff8f ${percentage}%, #fff ${percentage}%)`;
  }
  return ITEMSTATUS.find((d) => d.value === type).bgColor;
};
const styles = {
  container: {
    marginTop: "5px",
  },
  accordionHeader: {
    cursor: "pointer",
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
  },
  itemNameTab: {
    width: "230px",
  },
};

const ActiveOrderSelector = ({
  tables,
  lastOrderNumber,
  activeOrders,
  activeOrdersLength,
  active,
  branchCode,
  handleItemQuantity,

  deleteItem,
  makeTableActive,
  deletable,

  scrollable,
  deleteOrder,
  allItems,
  clearCount,
  handleSearchAndAddItem,
  disabled,
  hideSearch,
  orderType,
  isEditMode,
  tableType,
}) => {
  const dispatch = useDispatch();
  const tablesRef = React.useRef([]);

  // console.log(tableType);
  React.useEffect(() => {
    if (scrollable)
      tablesRef.current = tablesRef.current.slice(0, tables.length);
  }, [tables]);
  const executeScroll = (index) => {
    index &&
      tablesRef.current[tables.length - index] &&
      tablesRef.current[tables.length - index].scrollIntoView({
        behavior: "smooth",
        block: "end",
        inline: "nearest",
      });
  };

  const [importOpen, setImportOpen] = useState();
  const headers = [
    { title: "Item Name", key: "itemName" },

    { title: "Price", key: "itemPrice" },
  ];

  // console.log(tables);
  React.useEffect(() => {
    scrollable && executeScroll(active);
  }, [active]);
  return [...tables].reverse().map((data, dataIndex) => {
    const index = activeOrdersLength - 1 - dataIndex;
    const orderDeletable = data.orderItems.length === 0;
    const isActive = data.refId === active?.refId;

    const disableEverything = disabled
      ? true
      : data?.isEdited
      ? false
      : data.isOrderConfirmed;

    return (
      <>
        <div
          class="card border mb-1 shadow-none"
          // style={{ overflow: "auto" }}
          ref={(el) => (tablesRef.current[dataIndex] = el)}
        >
          <div
            class={`card-header ${isActive ? "bg-purple " : ""}`}
            style={{
              padding: "10px 10px",
              ...getColor(data.orderTypeId),
            }}
            onClick={() => makeTableActive(data.refId)}
          >
            <a
              href="javascript:void(0);"
              class={`text-dark mb-0 pb-0`}
              data-toggle="collapse"
              data-target={`#collapseOne${index}`}
              aria-expanded="true"
              aria-controls="collapseOne"
            >
              <div className="row " style={{ width: "100%" }}>
                {/* <div className="col-md-12 "> */}
                <div className="col-md-8">
                  {data.tableNumber ? (
                    <span
                      style={{
                        color: isActive ? "white" : undefined,
                      }}
                    >
                      Table Number: {data.tableNumber}{" "}
                    </span>
                  ) : (
                    <span
                      style={{
                        color: isActive ? "white" : undefined,
                      }}
                    >
                      {data?.orderType}
                    </span>
                  )}
                </div>
                <div className="col-md-2">
                  <span style={{ color: isActive ? "white" : undefined }}>
                    {data?.orderItems?.length} Items
                  </span>
                </div>
                {orderDeletable && !isEditMode && (
                  <div className="col-md-2 d-flex justify-content-end">
                    <span>
                      <a
                        href="javascript:void(0);"
                        onClick={(e) => {
                          e.stopPropagation();
                          deleteOrder(data.refId);
                        }}
                      >
                        <i
                          class={`mdi mdi-close-circle font-16 ${
                            isActive ? `text-primary` : " text-danger "
                          }`}
                        ></i>
                      </a>
                    </span>
                  </div>
                )}

                {/* </div> */}
                <div className="col-md-8">
                  <span
                    className={
                      isActive ? "badge badge-dark" : "badge badge-primary"
                    }
                    style={{ color: isActive ? "white" : undefined }}
                  >
                    {data?.branchOrderNumber}
                  </span>
                </div>
                <div className="col-md-4">
                  {isActive &&
                    active?.branchOrderNumber &&
                    active?.isOrderConfirmed && (
                      <span
                        className={"badge badge-warning"}
                        style={{ color: "black" }}
                      >
                        Confirmed
                      </span>
                    )}
                  {isActive && active?.branchOrderNumber && active?.isPaid && (
                    <span
                      className={"badge badge-success ml-1"}
                      style={{ color: "black" }}
                    >
                      Paid
                    </span>
                  )}
                  {/* {isActive && active?.isEdited && (
                    <span
                      className={"badge badge-light"}
                      style={{ color: "black" }}
                    >
                      Editing
                    </span>
                  )} */}
                </div>
              </div>
            </a>
          </div>
          <Collapse in={isActive}>
            <div class=" mt-0 pt-0 pl-1 pr-1 ">
              {data?.orderItems?.length > 0 ? (
                <table class="table table-sm mb-0 ordertable">
                  <tbody>
                    {data?.KOTS?.map((kot, index) => {
                      return (
                        <>
                          <div
                            style={{
                              padding: "0.4rem 0.75rem",
                              backgroundColor: "#9ba7ca",
                              color: "#fff",
                              margin: "0.3rem 0",
                            }}
                          >
                            <tr>
                              {kot?.kotNumber
                                ? `KOT ${kot?.kotNumber} `
                                : "Current Kot"}
                            </tr>
                          </div>
                          {kot?.orderItems?.map((item) => {
                            const { itemId } = item;
                            let toppings = [];
                            if (item?.activeTopping?.length > 0) {
                              item?.activeTopping?.map((topping) =>
                                toppings.push(topping.itemName)
                              );
                            }
                            const isConfirmed =
                              isEditMode ||
                              item.itemStatusId >= ITEMSTATUS[1].value;

                            return (
                              <>
                                <tr
                                  key={index}
                                  style={{
                                    background: getBgColor(
                                      item.itemStatusId,
                                      item.kotQuantity,
                                      item.quantity
                                    ),
                                  }}
                                >
                                  {/* <th scope="row">{index + 1}</th> */}
                                  <div>
                                    <div
                                      style={{
                                        ...styles.accordionHeader,
                                        width: "100%",
                                      }}
                                    >
                                      <td style={styles.itemNameTab}>
                                        {item.itemName}{" "}
                                        {toppings.length > 0 &&
                                          ` with ${toppings.join(" + ")}`}
                                      </td>
                                      <td style={{ whiteSpace: "nowrap" }}>
                                        {CURRENCY}{" "}
                                        {price(tableType, item) ||
                                          item.itemPrice}{" "}
                                      </td>
                                      <td>
                                        <ItemQuantitySelector
                                          quantity={item.quantity}
                                          setQuantity={
                                            (quantity, changeQty) =>
                                              handleItemQuantity({
                                                quantity: changeQty,
                                                itemId,
                                                index,
                                                item,
                                              })
                                            // console.log(quantity, changeQty)
                                          }
                                          deleteItem={() =>
                                            deleteItem(
                                              item,
                                              kot.kotNumber,
                                              index
                                            )
                                          }
                                          isOrderConfirmed={disableEverything}
                                          isKotCompleted={
                                            !isEditMode && isConfirmed
                                          }
                                        />
                                      </td>

                                      <td className="text-right">
                                        {CURRENCY}
                                        {item.quantity *
                                          (price(tableType, item) ||
                                            item.itemPrice)}
                                      </td>

                                      {!isEditMode && (
                                        <td>
                                          <a
                                            href="javascript:void(0);"
                                            onClick={() =>
                                              deleteItem(
                                                item,
                                                kot.kotNumber,
                                                index
                                              )
                                            }
                                          >
                                            <i class="mdi mdi-close-circle-outline text-danger font-16"></i>
                                          </a>
                                        </td>
                                      )}
                                    </div>
                                  </div>
                                </tr>
                              </>
                            );
                          })}
                        </>
                      );
                    })}
                  </tbody>
                </table>
              ) : (
                <p class="mb-0 text-muted p-2">No Items Selected</p>
              )}

              {!hideSearch && (
                <ListItemSelector
                  allItems={allItems}
                  clearCount={clearCount}
                  handleSearchAndAddItem={handleSearchAndAddItem}
                />
              )}
              {!active?.isPaid && <OrderConfirmation data={data} />}
            </div>
          </Collapse>
        </div>
      </>
    );
  });
};

export default ActiveOrderSelector;
